<template>
  <div class="layout-wrapper">
    <div
      class="layout-header"
      :style="styleObject"
      ref="headstyle"
    >
      <div class="logobox">
        <JySidebarLogo
          v-if="true"
          :collapse="true"
        />
      </div>
      <JyNavBar
        :isShowMenuCode="isShowMenuCode"
        :getdspnum="getdspnum"
      />
    </div>

    <div v-if="$route.path=== '/Approve' || $route.path === '/Approvainfo' || $route.path === '/Notauth'">
      <keep-alive>
        <router-view
          v-if="$route.path=== '/Approve'"
          style="min-height: calc(100vh - 60px);"
        />
      </keep-alive>
      <router-view
        v-if="$route.path != '/Approve'"
        style="min-height: calc(100vh - 60px);"
      />
    </div>
    <div v-else-if="$route.path === '/Otherpage'">
      <router-view
        style="min-height: calc(100vh - 60px);"
      />
    </div>
    <div
      v-else
      class="layout-content"
    >
      <div
        class="leftnavigation"
        :style=" isCollapse ?  'width:68px':'width: 240px;' "
      >
        <div class="leftSelect">
          <el-select
            v-model="nowSystem"
            placeholder="请选择"
            @change="changeSystem"
            style="width:220px"
            size="small"
          >
            <el-option
              v-for="item in arr"
              :key="item.url"
              :label="item.sysName"
              :value="item.sysCode"
              class="leftSelectItem"
            >
              <span class="leftSelectSysName">{{ item.sysName }}</span>

              <span
                v-if="menuRemaskObj[item.sysCode]"
                class="leftSelectRemask"
              >{{ menuRemaskObj[item.sysCode] }}</span>
            </el-option>
          </el-select>

          <i class="leftSelectIcon el-icon-plus"></i>
        </div>
        <div class="leftcontent">
          <el-menu
            class="el-menu-vertical-demo"
            :collapse="isCollapse"
            :unique-opened="true"
            background-color="rgb(249, 251, 255)"
            :default-active="defaultActive"
            :key="elMenuKey"
            :collapse-transition="false"
          >
            <div v-if="nowSystemList.length>0">
              <template v-for="(item,index) in nowSystemList">
                <el-submenu
                  v-if="item.subMenus.length"
                  :index="index + ''"
                  :key="String(index+item.pid)"
                >
                  <template slot="title">
                    <i :class="item.modelIcon ||'el-icon-odometer'"></i>
                    <span slot="title">{{item.menuName}}</span>
                  </template>

                  <el-menu-item
                    v-for="(i, x) in item.subMenus"
                    :index="i.menuUrl"
                    :key="i.menuId"
                    @click="showrouterlistNew(i)"
                  >{{i.menuName }}</el-menu-item>
                </el-submenu>
                <template v-else>
                  <el-menu-item
                    :index="item.menuUrl"
                    :key="item.menuId"
                    @click="showrouterlistNew(item)"
                  >
                    <i :class="item.modelIcon ?item.modelIcon : 'el-icon-odometer'"></i>
                    <span slot="title">{{item.menuName}}</span>
                  </el-menu-item>
                </template>
              </template>
            </div>
            <el-empty v-else></el-empty>
          </el-menu>
        </div>
      </div>

      <div
        @click="changeFold "
        class="hamburger"
        :style=" isCollapse ? 'left: 68px;' :'left: 240px;'"
      >
        <i :class="isCollapse ?'el-icon-s-unfold':'el-icon-s-fold'"></i>
      </div>
      <!-- 子系统 -->
      <div
        class="right-viewport"
        id="subapp-viewport"
        style="margin-top:0px"
      />
    </div>
  </div>
</template>

<script>
import { getMenus } from '@/api/menus'
import { AuthNavigationbar } from '@/api/main/main'

import store from '@/store'
export default {
  name: 'App',
  data () {
    return {
      isShowMenuCode: [], // 材料库 以及投标盒子是否显示
      getdspnum: 1,
      styleObject: {
        'z-index': 1900
      },
      arr: [],
      activeRule: '',
      nowSystem: '', // 初始化的时候选择的系统
      defaultActive: '', // 当前默认选中的 那个 二级项目
      elMenuKey: 0,
      nowSystemList: [], // 当前操作的系统
      isCollapse: false, //  左侧边栏是展开还是收起  false展开 true收起
      menuRemaskObj: {
        audit: '审计作业、报告号领取、文件用章、外勤计划等',
        manufacturingcost: '单项目/全过程项目作业、报告号领取、文件用章等',
        bid: '项目创建、招标流程执行、标段进度管理等',
        supervisor: '项目进展跟踪、现场作业记录、成员产出统计等',
        projectmanage: '项目作业、文件用章、项目归档等',
        assess: '评估作业、文件用章、项目归档等',
        survey: '测绘作业、文件用章、项目归档等',
        development: '测绘作业、文件用章、项目归档等',
        tender: '项目作业、文件用章、项目归档等',
        bim: 'BIM作业、文件用章、项目归档等',
        contract: '独立合同/框架协议/联合体合同维护、客户单位维护等',
        purchasing: '采购申请、物品询价表等',
        sso: '考勤管理、人事入调离转管理、组织管理等',
        salary: '月度薪资计算、提成计算、绩效计划配置等',
        finance: '发票、收款、支出、报销等管理，业务综合台账',
        synthesize: '公告发布、材料库维护、就餐分组',
        datastatistics: '项目数据多维度可视化展示',
        archives: '项目资料线上、线下归档',
        study: '弘扬企业文化，紧跟企业发展',
        thr: '投标方案在线协同编制、投标资质综合管理',
        lawyer: '律所作业、文件用章、项目归档等',
        businessconfig: '角色、账号管理，审批流维护，各业务基础信息维护',
        configuration: '管理员专用'
      } // 当前所有业务系统的描述
    }
  },
  computed: {
    state () {
      // 返回所有的state则不需添加参数
      return store.getGlobalState()
    }
  },
  watch: {
  },

  created () {
    this.getsidbarlist()
    this.getAuth()
  },
  destroyed () {
  },
  mounted () { },
  components: {},
  methods: {
    getAuth () {
      getMenus().then(res => {
        if (res.status === 200) {
          this.isShowMenuCode = res.data
        }
      })
    },
    getnotefound () {
      // 去404页面
      history.pushState(null, '', '#/Notfound')
    },
    // 新的 点击 某一个二级菜单
    showrouterlistNew (i) {
      this.getdspnum += 1
      var src = this.nowSystem + '#' + i.menuUrl
      this.defaultActive = i.menuUrl
      history.pushState(null, '', src)
    },
    // 获取左侧的list
    getsidbarlist () {
      var path = window.location.pathname
      // defaultActive
      if (this.$authListDate.length !== 0) {
        this.arr = this.$authListDate
        if (
          path === undefined ||
          (path === '/' && window.location.hash === '') ||
          (path === '/' && window.location.hash === '#/')
        ) {
          history.pushState(null, '', this.arr[0].activeRule)
          this.nowSystemList = this.arr[0].authMenus
          this.nowSystem = this.arr[0].sysCode // 初始化的时候选择第一个系统
        } else {
          for (var j = 0; j < this.arr.length; j++) {
            if (path === this.arr[j].activeRule) {
              this.nowSystemList = this.arr[j].authMenus
              this.nowSystem = this.arr[j].sysCode // 初始化的时候选择第一个系统
              // 这里给一个默认的高亮菜单，有的高亮没有就不高亮 得到#后面的路由数据
              this.defaultActive = window.location.hash.slice(1)
            }
          }
        }
      } else {
        AuthNavigationbar({}).then(res => {
          if (res.status === 200) {
            this.arr = res.data
            if (
              path === undefined ||
              (path === '/' && window.location.hash === '') ||
              (path === '/' && window.location.hash === '#/')
            ) {
              history.pushState(null, '', this.arr[0].activeRule)
              this.nowSystemList = this.arr[0].authMenus
              this.nowSystem = this.arr[0].sysCode // 初始化的时候选择第一个系统
            } else {
              for (var j = 0; j < this.arr.length; j++) {
                if (path === this.arr[j].activeRule) {
                  this.nowSystemList = this.arr[j].authMenus
                  this.nowSystem = this.arr[j].sysCode // 选择已定位的路由系统
                  this.defaultActive = this.arr[j].menuUrl
                }
              }
            }
          }
        })
      }
    },
    // 新开始
    // 选择当前要操作 的系统
    changeSystem (e, path) {
      this.nowSystemList = []
      var obj = this.arr.find(item => {
        return item.sysCode === e
      })
      this.nowSystemList = obj.authMenus
      if (path) { // . 暂时没有走传path的逻辑
        this.showrouterlistNew(path)
        this.getdspnum += 1
        var src = this.nowSystem + path
        this.defaultActive = path
        history.pushState(null, '', src)
        this.elMenuKey++
      } else {
        // 跳转到当前系统的首页
        var a = {}
        if (this.nowSystemList[0].subMenus.length) {
          a = this.nowSystemList[0].subMenus[0]
        } else {
          a = this.nowSystemList[0]
        }
        this.showrouterlistNew(a)
        this.elMenuKey++
      }
    },
    // 收起 和折叠
    changeFold () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0 !important;
  padding: 0;
  height: 100%;
}

.layout-wrapper {
  padding-top: 60px;
  position: relative;
  .logobox {
    width: 114;
    height: 30px;
    float: left;
  }

  .layout-header {
    position: fixed;
    top: 0;
    background-color: #ffffff;
    height: 60px;
    width: 100%;
    box-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.1), 0 1px 20px rgba(0, 0, 0, 0.1);

    line-height: 60px;
    .logo {
      float: left;
      margin: 0 50px;
    }
  }

  //新加的样式

  .layout-content {
    background: rgb(249, 251, 255);
    height: calc(100vh - 60px);
    position: relative;
    display: flex;

    //左侧的 选择系统的select
    .leftnavigation {
      width: 240px;
      // height: 100%;
      border-right: 1px solid #e5e9ef;
      position: relative;
      left: 0;
      .leftSelect {
        padding: 14px 10px;
        box-sizing: border-box;
        height: 60px;
        border-bottom: 1px solid #e5e9ef;
        position: relative;

        .leftSelectIcon {
          position: absolute;
          font-size: 12px;
          color: #606266;
          bottom: -6px;
          right: -6px;
          z-index: 99;
        }
      }

      .leftcontent {
        width: 100%;
        background: rgb(249, 251, 255) !important;
        height: calc(100vh - 120px);
        overflow-y: scroll;
        :-webkit-scrollbar {
          width: 0 !important;
        }
        .el-menu-item [class^="el-icon-"] {
          font-size: 18px !important;
          color: #909399 !important;
          margin-right: 5px !important;
        }
        .el-menu-item .iconfont {
          font-size: 18px !important;
          margin-right: 5px;
          width: 24px;
          text-align: center;
          display: inline-block;
        }
        //样式调整
        .el-submenu :hover {
          background-color: #edf0f6 !important;
        }
        .el-menu-item:hover {
          background-color: #edf0f6 !important;
        }
        .el-menu-item.is-active {
          color: #4776ff;
          background-color: #edf0f6 !important;
        }
        .el-menu-item.is-active::before {
          content: "";
          width: 4px;
          height: 100%;
          left: 0px;
          position: absolute;
          background: #4776ff;
        }
      }

      // 左侧的 路由box el-menu 一些样式更改
      .el-menu {
        border-right: none;
      }
    }
    //右侧 的 展开缩起 按钮
    .hamburger {
      position: absolute;

      top: 16px;
      font-size: 28px;
      width: 50px;
      text-align: center;
      z-index: 99;
    }
    .hamburger:hover {
      cursor: pointer;
      background: rgba(0, 0, 0, 0.025);
    }

    //右侧的
    .right-viewport {
      flex: 1;
      width: calc(100vh - 240px);
      height: 100%;
    }
  }
}
</style>

<style lang="scss">
//新加的样式
.leftSelectItem {
  min-height: 50px;
  .leftSelectSysName {
    height: 30px;
    font-size: 16px;
    display: block;
  }
  .leftSelectRemask {
    display: block;
    color: #8492a6;
    font-size: 12px;
    line-height: 10px;
  }
  .leftSelectRemask.selected {
    font-weight: 400;
  }
}

//样式调整
.el-submenu :hover {
  background-color: #edf0f6 !important;
}
.el-menu-item:hover {
  background-color: #edf0f6 !important;
}
.el-submenu__title {
}
.layout-wrapper
  .layout-content
  .leftnavigation
  .leftcontent::-webkit-scrollbar {
  width: 16px !important;
}

.layout-wrapper
  .layout-content
  .leftnavigation
  .leftcontent::-webkit-scrollbar-track {
  background: #f1f1f1;
}
// 左侧菜单的滚动条箭头样式
.el-submenu__title {
  color: #161616 !important;
}
// down
.layout-wrapper
  .layout-content
  .leftnavigation
  .leftcontent::-webkit-scrollbar-button:single-button:vertical:increment {
  border-width: 8px 8px 0 6px;
  background-color: #f1f1f1;
  display: block;
  border-style: solid;
  border-color: #555555 transparent transparent transparent;
}
// up
.layout-wrapper
  .layout-content
  .leftnavigation
  .leftcontent::-webkit-scrollbar-button:single-button:vertical:decrement {
  border-width: 0 8px 8px 8px;
  background-color: #f1f1f1;
  display: block;
  border-style: solid;
  border-color: transparent transparent #555555 transparent;
}
</style>
